"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-filippo-del-mela": {
    "103a60f8": [{
      "hkey": "2606ed63",
      "slug": "olivarella-corriolo",
      "name": "Olivarella-Corriolo",
      "primary": true,
      "skipSearch": false
    }],
    "corriolo": [{
      "hkey": "2606ed63",
      "slug": "olivarella-corriolo",
      "name": "Olivarella-Corriolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-filippo-del-mela"
    }],
    "0af5ee4b": [{
      "hkey": "2606ed63",
      "slug": "olivarella-corriolo",
      "name": "Olivarella-Corriolo",
      "primary": true,
      "skipSearch": false
    }],
    "olivarella": [{
      "hkey": "2606ed63",
      "slug": "olivarella-corriolo",
      "name": "Olivarella-Corriolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;